import React, { createElement, CSSProperties, ReactNode } from "react"
import { t } from "../../i18n"

export interface HeaderProps {
  className?: string;
  children?: ReactNode;
  i18nKey?: string;
  level?: "1" | "2" | "3" | "4" | "5" | "6";
  gap?: string;
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { children, i18nKey, gap } = props
  const className = props.className || "text-3xl font-extrabold"
  const level = props.level || "1"

  const style: CSSProperties = {}
  if (gap) style.marginTop = gap

  return createElement(`h${level}`, { className, style }, children || t(i18nKey))
}

export default Header
